var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.70657 7.44336C10.2066 8.94336 10.2066 11.37 8.70657 12.8634C7.20657 14.3567 4.7799 14.3634 3.28656 12.8634C1.79323 11.3634 1.78656 8.93669 3.28656 7.44336",
    stroke: "#2F3137",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.06062 9.09031C5.50062 7.53031 5.50062 4.99698 7.06062 3.43031C8.62062 1.86365 11.154 1.87031 12.7206 3.43031C14.2873 4.99031 14.2806 7.52365 12.7206 9.09031",
    stroke: "#2F3137",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.634e06e5665a851166a696cd9a64735b.svg";
export { ForwardRef as ReactComponent };